import script from "./JobConfigsAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./JobConfigsAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./JobConfigsAdministrar.vue?vue&type=style&index=0&id=df20ccf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df20ccf2"]])

export default __exports__